<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      class="ag-theme-balham ag-grid-listado-tipos-documentos-persona"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :rowSelection="rowSelection"
      :pagination="pagination"
      :rowClassRules="rowClassRules"
      :columnDefs="columnDefs"
      :rowData="rowData"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../../mixins/listado-ag-grid.mixin';
import { TEXTOS_TIPOS_CAMPOS } from '../../utils/constantes';
import { cellRendererNumeroRegistro, cellRendererSiONo } from '../../utils/funciones';

export default {
  name: 'ListadoTiposDocumentosPersona',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          minWidth: 300,
        },
        {
          headerName: 'PROPÓSITO',
          field: 'proposito',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ES REUTILIZABLE',
          field: 'esReutilizable',
          cellRenderer: cellRendererSiONo('esReutilizable', 'Sí', 'No'),
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'APLICA FECHA VENCIMIENTO',
          field: 'aplicaFechaVencimiento',
          cellRenderer: cellRendererSiONo('aplicaFechaVencimiento', 'Sí', 'No'),
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'PERMITE PRÓRROGA',
          field: 'permiteProrroga',
          cellRenderer: cellRendererSiONo('permiteProrroga', 'Sí', 'No'),
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'REQUIERE VALIDACIÓN',
          field: 'requiereValidacion',
          cellRenderer: cellRendererSiONo('requiereValidacion', 'Sí', 'No'),
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'CAMPOS ADICIONALES',
          autoHeight: true,
          minWidth: 800,
          maxWidth: 800,
          filter: false,
          headerComponentParams: {
            template: /* html*/ `
            <table width="100%" style="border-collapse">
              <thead>
                <tr>
                  <th style="font-size: 12px; font-weight: 600; width: 300px;">NOMBRE</th>
                  <th style="font-size: 12px; font-weight: 600; width: 200px;">TIPO</th>
                  <th style="font-size: 12px; font-weight: 600; width: 300px;">ETIQUETA</th>
                </tr>
              </thead>
            </table>`,
          },
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            } else {
              const textosTiposCampos = TEXTOS_TIPOS_CAMPOS;
              let detalle = /* html*/ `

              <table width="100%" style="border-collapse: collapse;">
                <tbody>`;

              params.data.plantillaDatos.forEach((campo) => {
                detalle += /* html*/ `
                <tr>
                  <td style="font-size: 13px; width: 300px;">${campo.nombre}</td>
                  <td style="font-size: 13px; width: 200px;">${textosTiposCampos[campo.tipo]}</td>
                  <td style="font-size: 13px; width: 300px;">${campo.etiqueta}</td>
                </tr>`;
              });

              detalle += /* html*/ `
                </tbody>
              </table>`;

              return detalle;
            }
          },
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-tipos-documentos-persona {
  height: calc(var(--vh, 1vh) * 100 - 14.5rem);
}
</style>
  